/**
 * @generated SignedSource<<c514c3706f18547ae4fc540a9c00292c>>
 * @relayHash fa719725403f4bc1ff9fcf3963fd7531
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b26287f48d375f663a90706c430c6c76696991a26001b463cbad9ab4ffac35a7

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type HelpLayoutFilter = {
  isEditMode?: boolean | null | undefined;
};
export type viewHomepageQuery$variables = {
  cloudId: string;
  filter?: HelpLayoutFilter | null | undefined;
  helpCenterAri: string;
  layoutAri: string;
};
export type viewHomepageQuery$data = {
  readonly helpCenter: {
    readonly helpCenterById: {
      readonly __typename: "QueryError";
      readonly announcements?: {
        readonly canEditHomePageAnnouncement: boolean | null | undefined;
      } | null | undefined;
      readonly name?: {
        readonly default: string;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly helpLayout: {
    readonly layout: {
      readonly __typename: "QueryError";
      readonly extensions?: ReadonlyArray<{
        readonly statusCode: number | null | undefined;
      }> | null | undefined;
      readonly message?: string | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"layoutViewRendererFragment">;
    };
  } | null | undefined;
};
export type viewHomepageQuery = {
  response: viewHomepageQuery$data;
  variables: viewHomepageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "helpCenterAri"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "layoutAri"
},
v4 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v5 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  }
],
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "HelpCenterName",
      "kind": "LinkedField",
      "name": "name",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "default"
        }
      ]
    },
    {
      "concreteType": "HelpCenterAnnouncements",
      "kind": "LinkedField",
      "name": "announcements",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "canEditHomePageAnnouncement"
        }
      ]
    }
  ],
  "type": "HelpCenter"
},
v7 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v8 = [
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  },
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "layoutAri"
  }
],
v9 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v10 = {
  "kind": "ScalarField",
  "name": "message"
},
v11 = {
  "kind": "ScalarField",
  "name": "id"
},
v12 = {
  "kind": "InlineFragment",
  "selections": [
    (v11/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v13 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
],
v14 = {
  "kind": "ScalarField",
  "name": "key"
},
v15 = {
  "kind": "ScalarField",
  "name": "name"
},
v16 = {
  "kind": "ScalarField",
  "name": "logo"
},
v17 = {
  "kind": "ScalarField",
  "name": "portalId"
},
v18 = {
  "concreteType": "HelpLayoutVisualConfig",
  "kind": "LinkedField",
  "name": "visualConfig",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "titleColor"
    }
  ]
},
v19 = {
  "concreteType": "HelpLayoutAtomicElementType",
  "kind": "LinkedField",
  "name": "elementType",
  "plural": false,
  "selections": [
    (v14/*: any*/)
  ]
},
v20 = {
  "kind": "ScalarField",
  "name": "hidden"
},
v21 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v22 = {
  "kind": "ScalarField",
  "name": "backgroundColor"
},
v23 = {
  "kind": "ScalarField",
  "name": "backgroundType"
},
v24 = {
  "concreteType": "HelpLayoutBackgroundImage",
  "kind": "LinkedField",
  "name": "backgroundImage",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "url"
    }
  ]
},
v25 = {
  "kind": "LinkedField",
  "name": "extensions",
  "plural": true,
  "selections": [
    (v7/*: any*/),
    (v9/*: any*/)
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "viewHomepageQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v5/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v7/*: any*/)
                ],
                "type": "QueryError"
              }
            ]
          }
        ]
      },
      {
        "args": (v4/*: any*/),
        "concreteType": "HelpLayoutQueryApi",
        "kind": "LinkedField",
        "name": "helpLayout",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "args": (v8/*: any*/),
              "kind": "LinkedField",
              "name": "layout",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "layoutViewRendererFragment"
                    }
                  ],
                  "type": "HelpLayout"
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "name": "extensions",
                      "plural": true,
                      "selections": [
                        (v9/*: any*/)
                      ]
                    },
                    (v10/*: any*/),
                    (v7/*: any*/)
                  ],
                  "type": "QueryError"
                }
              ]
            },
            "action": "THROW",
            "path": "helpLayout.layout"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "viewHomepageQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v5/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v6/*: any*/),
              (v12/*: any*/)
            ]
          }
        ]
      },
      {
        "args": (v4/*: any*/),
        "concreteType": "HelpLayoutQueryApi",
        "kind": "LinkedField",
        "name": "helpLayout",
        "plural": false,
        "selections": [
          {
            "args": (v8/*: any*/),
            "kind": "LinkedField",
            "name": "layout",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "args": (v13/*: any*/),
                    "concreteType": "HelpLayoutSectionConnection",
                    "kind": "LinkedField",
                    "name": "sections",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "concreteType": "HelpLayoutSectionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "HelpLayoutSection",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "HelpLayoutSubsection",
                                "kind": "LinkedField",
                                "name": "subsections",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "HelpLayoutSubsectionConfig",
                                    "kind": "LinkedField",
                                    "name": "config",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "span"
                                      }
                                    ]
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "name": "elements",
                                    "plural": true,
                                    "selections": [
                                      (v7/*: any*/),
                                      {
                                        "kind": "TypeDiscriminator",
                                        "abstractKey": "__isHelpLayoutElement"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "adf"
                                          },
                                          {
                                            "concreteType": "HelpLayoutAtomicElementType",
                                            "kind": "LinkedField",
                                            "name": "elementType",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "args": [
                                                  {
                                                    "kind": "Variable",
                                                    "name": "parentAri",
                                                    "variableName": "helpCenterAri"
                                                  }
                                                ],
                                                "concreteType": "HelpLayoutMediaConfig",
                                                "kind": "LinkedField",
                                                "name": "mediaConfig",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "mediaCollectionName"
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "mediaToken"
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "mediaUrl"
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "asapIssuer"
                                                  }
                                                ]
                                              },
                                              (v14/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "HelpLayoutEditorElement"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "HelpLayoutPortalCard",
                                            "kind": "LinkedField",
                                            "name": "portals",
                                            "plural": true,
                                            "selections": [
                                              (v15/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "name": "description"
                                              },
                                              (v16/*: any*/),
                                              (v17/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "name": "isFeatured"
                                              }
                                            ]
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "expandButtonTextColor"
                                          },
                                          (v18/*: any*/),
                                          (v19/*: any*/)
                                        ],
                                        "type": "HelpLayoutPortalsListElement"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "HelpLayoutRequestForm",
                                            "kind": "LinkedField",
                                            "name": "suggestedRequestTypes",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "descriptionHtml"
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "name": "portalName"
                                              },
                                              (v11/*: any*/),
                                              (v17/*: any*/),
                                              (v15/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "name": "iconUrl"
                                              }
                                            ]
                                          },
                                          (v18/*: any*/),
                                          (v19/*: any*/)
                                        ],
                                        "type": "HelpLayoutSuggestedRequestFormsListElement"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "header"
                                          },
                                          (v10/*: any*/),
                                          (v19/*: any*/)
                                        ],
                                        "type": "HelpLayoutAnnouncementElement"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "HelpLayoutTopic",
                                            "kind": "LinkedField",
                                            "name": "topics",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "topicId"
                                              },
                                              (v20/*: any*/),
                                              {
                                                "concreteType": "HelpLayoutTopicItem",
                                                "kind": "LinkedField",
                                                "name": "items",
                                                "plural": true,
                                                "selections": [
                                                  (v7/*: any*/),
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "title"
                                                  },
                                                  (v16/*: any*/),
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "displayLink"
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "entityKey"
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "helpObjectType"
                                                  },
                                                  (v21/*: any*/)
                                                ]
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "name": "topicName"
                                              }
                                            ]
                                          },
                                          (v18/*: any*/),
                                          (v19/*: any*/)
                                        ],
                                        "type": "HelpLayoutTopicsListElement"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "useGlobalSettings"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "homePageTitle"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "userLanguageTag"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "showCSMAISearchTrigger"
                                          },
                                          {
                                            "concreteType": "HelpLayoutVisualConfig",
                                            "kind": "LinkedField",
                                            "name": "visualConfig",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "foregroundColor"
                                              },
                                              (v22/*: any*/),
                                              (v23/*: any*/),
                                              (v24/*: any*/)
                                            ]
                                          },
                                          (v19/*: any*/)
                                        ],
                                        "type": "HelpLayoutHeroElement"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v19/*: any*/)
                                        ],
                                        "type": "HelpLayoutNoContentElement"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "forgeElementType"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "forgeElementPage"
                                          },
                                          (v19/*: any*/)
                                        ],
                                        "type": "HelpLayoutForgeElement"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "connectElementPage"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "connectElementType"
                                          },
                                          (v19/*: any*/)
                                        ],
                                        "type": "HelpLayoutConnectElement"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "identifier"
                                          },
                                          (v25/*: any*/),
                                          (v10/*: any*/)
                                        ],
                                        "type": "QueryError"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "HelpLayoutBreadcrumb",
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "relativeUrl"
                                              },
                                              (v15/*: any*/)
                                            ]
                                          },
                                          (v19/*: any*/)
                                        ],
                                        "type": "HelpLayoutBreadcrumbElement"
                                      },
                                      (v12/*: any*/),
                                      (v21/*: any*/)
                                    ]
                                  },
                                  (v11/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "concreteType": "HelpLayoutVisualConfig",
                                        "kind": "LinkedField",
                                        "name": "visualConfig",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "HelpLayoutAlignmentSettings",
                                            "kind": "LinkedField",
                                            "name": "alignment",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "horizontalAlignment"
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "name": "verticalAlignment"
                                              },
                                              (v21/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ],
                                    "type": "HelpLayoutVisualEntity",
                                    "abstractKey": "__isHelpLayoutVisualEntity"
                                  },
                                  (v21/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "HelpLayoutVisualConfig",
                                "kind": "LinkedField",
                                "name": "visualConfig",
                                "plural": false,
                                "selections": [
                                  (v22/*: any*/),
                                  (v23/*: any*/),
                                  (v24/*: any*/),
                                  (v20/*: any*/)
                                ]
                              },
                              (v11/*: any*/),
                              (v7/*: any*/),
                              (v21/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "cursor"
                          }
                        ]
                      },
                      {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "endCursor"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                          }
                        ]
                      }
                    ],
                    "storageKey": "sections(first:10)"
                  },
                  {
                    "args": (v13/*: any*/),
                    "handle": "connection",
                    "key": "layoutRendererFragment_sections",
                    "kind": "LinkedHandle",
                    "name": "sections"
                  },
                  (v11/*: any*/)
                ],
                "type": "HelpLayout"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v25/*: any*/),
                  (v10/*: any*/)
                ],
                "type": "QueryError"
              },
              (v12/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "b26287f48d375f663a90706c430c6c76696991a26001b463cbad9ab4ffac35a7",
    "metadata": {},
    "name": "viewHomepageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "2bcab35a024f85aecee6a272f8d5db60";

export default node;
